exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-2xg6q{font-weight:600;margin-bottom:10px}.fileIcon-3emfQ{margin-right:6px}.container-VzIe1{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer}.fileTooltip-1KGqv{max-width:300px;word-wrap:break-word}", ""]);

// exports
exports.locals = {
	"file": "file-2xg6q",
	"fileIcon": "fileIcon-3emfQ",
	"container": "container-VzIe1",
	"fileTooltip": "fileTooltip-1KGqv"
};